import { render, staticRenderFns } from "./Form2316.vue?vue&type=template&id=c8086e7e&scoped=true"
import script from "./Form2316.vue?vue&type=script&lang=js"
export * from "./Form2316.vue?vue&type=script&lang=js"
import style0 from "./Form2316.vue?vue&type=style&index=0&id=c8086e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8086e7e",
  null
  
)

export default component.exports